// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Takeaway = /* #__PURE__ */ (function () {
    function Takeaway() {

    };
    Takeaway.value = new Takeaway();
    return Takeaway;
})();
var Uber = /* #__PURE__ */ (function () {
    function Uber() {

    };
    Uber.value = new Uber();
    return Uber;
})();
var Glovo = /* #__PURE__ */ (function () {
    function Glovo() {

    };
    Glovo.value = new Glovo();
    return Glovo;
})();
var Wolt = /* #__PURE__ */ (function () {
    function Wolt() {

    };
    Wolt.value = new Wolt();
    return Wolt;
})();
var Online = /* #__PURE__ */ (function () {
    function Online() {

    };
    Online.value = new Online();
    return Online;
})();
var Phone = /* #__PURE__ */ (function () {
    function Phone() {

    };
    Phone.value = new Phone();
    return Phone;
})();
var Bar = /* #__PURE__ */ (function () {
    function Bar() {

    };
    Bar.value = new Bar();
    return Bar;
})();
var Portal = /* #__PURE__ */ (function () {
    function Portal() {

    };
    Portal.value = new Portal();
    return Portal;
})();
var Other = /* #__PURE__ */ (function () {
    function Other() {

    };
    Other.value = new Other();
    return Other;
})();
var Pyszne = /* #__PURE__ */ (function () {
    function Pyszne() {

    };
    Pyszne.value = new Pyszne();
    return Pyszne;
})();
var PizzaPortal = /* #__PURE__ */ (function () {
    function PizzaPortal() {

    };
    PizzaPortal.value = new PizzaPortal();
    return PizzaPortal;
})();
var Custom = /* #__PURE__ */ (function () {
    function Custom(value0) {
        this.value0 = value0;
    };
    Custom.create = function (value0) {
        return new Custom(value0);
    };
    return Custom;
})();
var ExternalIntegration = /* #__PURE__ */ (function () {
    function ExternalIntegration(value0) {
        this.value0 = value0;
    };
    ExternalIntegration.create = function (value0) {
        return new ExternalIntegration(value0);
    };
    return ExternalIntegration;
})();
var Apetilo = /* #__PURE__ */ (function () {
    function Apetilo() {

    };
    Apetilo.value = new Apetilo();
    return Apetilo;
})();
var eqExternalOrderOrigin = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return true;
            };
            if (x instanceof Uber && y instanceof Uber) {
                return true;
            };
            if (x instanceof Glovo && y instanceof Glovo) {
                return true;
            };
            if (x instanceof Wolt && y instanceof Wolt) {
                return true;
            };
            return false;
        };
    }
};
var eqOrderOrigin = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Online && y instanceof Online) {
                return true;
            };
            if (x instanceof Phone && y instanceof Phone) {
                return true;
            };
            if (x instanceof Bar && y instanceof Bar) {
                return true;
            };
            if (x instanceof Portal && y instanceof Portal) {
                return true;
            };
            if (x instanceof Other && y instanceof Other) {
                return true;
            };
            if (x instanceof Pyszne && y instanceof Pyszne) {
                return true;
            };
            if (x instanceof PizzaPortal && y instanceof PizzaPortal) {
                return true;
            };
            if (x instanceof Custom && y instanceof Custom) {
                return x.value0 === y.value0;
            };
            if (x instanceof ExternalIntegration && y instanceof ExternalIntegration) {
                return Data_Eq.eq(eqExternalOrderOrigin)(x.value0.externalOrderOrigin)(y.value0.externalOrderOrigin) && x.value0.integratorName === y.value0.integratorName;
            };
            if (x instanceof Apetilo && y instanceof Apetilo) {
                return true;
            };
            return false;
        };
    }
};
var ordExternalOrderOrigin = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Takeaway) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Takeaway) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Uber && y instanceof Uber) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Uber) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Uber) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Glovo && y instanceof Glovo) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Glovo) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Glovo) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Wolt && y instanceof Wolt) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 26, column 1 - line 26, column 40): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqExternalOrderOrigin;
    }
};
var ordOrderOrigin = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Online && y instanceof Online) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Online) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Online) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Phone && y instanceof Phone) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Phone) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Phone) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Bar && y instanceof Bar) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Bar) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Bar) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Portal && y instanceof Portal) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Portal) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Portal) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Other && y instanceof Other) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Other) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Other) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Pyszne && y instanceof Pyszne) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Pyszne) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Pyszne) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof PizzaPortal && y instanceof PizzaPortal) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof PizzaPortal) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof PizzaPortal) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Custom && y instanceof Custom) {
                return Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
            };
            if (x instanceof Custom) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Custom) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ExternalIntegration && y instanceof ExternalIntegration) {
                var v = Data_Ord.compare(ordExternalOrderOrigin)(x.value0.externalOrderOrigin)(y.value0.externalOrderOrigin);
                if (v instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                return Data_Ord.compare(Data_Ord.ordString)(x.value0.integratorName)(y.value0.integratorName);
            };
            if (x instanceof ExternalIntegration) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ExternalIntegration) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Apetilo && y instanceof Apetilo) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 43, column 1 - line 43, column 32): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqOrderOrigin;
    }
};
var genericOrderOrigin = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Online.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Phone.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Bar.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Portal.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return Other.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return Pyszne.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return PizzaPortal.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new Custom(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new ExternalIntegration(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
            return Apetilo.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 32, column 1 - line 32, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Online) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Phone) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Bar) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Portal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Other) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof Pyszne) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof PizzaPortal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof Custom) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof ExternalIntegration) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof Apetilo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 32, column 1 - line 32, column 77): " + [ x.constructor.name ]);
    }
};
var genericExternalOrderOrigin = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Takeaway.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Uber.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Glovo.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return Wolt.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 15, column 1 - line 15, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Takeaway) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Uber) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Glovo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Wolt) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 15, column 1 - line 15, column 93): " + [ x.constructor.name ]);
    }
};
var showExternalOrderOrigin = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericExternalOrderOrigin)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Takeaway";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Uber";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Glovo";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Wolt";
        }
    })))))
};
var showOrderOrigin = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderOrigin)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Phone";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Bar";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Portal";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Other";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Pyszne";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PizzaPortal";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Custom";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "externalOrderOrigin";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "integratorName";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(showExternalOrderOrigin))))({
        reflectSymbol: function () {
            return "ExternalIntegration";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Apetilo";
        }
    })))))))))))
};
var unscrambleDecodeExternalOrderOrigin = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericExternalOrderOrigin)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Takeaway";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Uber";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Glovo";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Wolt";
        }
    })))))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodeOrderOrigin = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderOrigin)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Phone";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Bar";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Portal";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Other";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Pyszne";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "PizzaPortal";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Custom";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeString1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ExternalIntegration";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "externalOrderOrigin";
        }
    })(unscrambleDecodeExternalOrderOrigin)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "integratorName";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Apetilo";
        }
    }))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeExternalOrderOrigin = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericExternalOrderOrigin)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Takeaway";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Uber";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Glovo";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Wolt";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodeOrderOrigin = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericOrderOrigin)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Online";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Phone";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Bar";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Portal";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Other";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Pyszne";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PizzaPortal";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Custom";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ExternalIntegration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "integratorName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "externalOrderOrigin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeExternalOrderOrigin))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Apetilo";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))))))))(encodingOpts)
};
var decodeExternalOrderOrigin = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericExternalOrderOrigin)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Takeaway";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Uber";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Glovo";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Wolt";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodeOrderOrigin = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericOrderOrigin)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Online";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Phone";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Bar";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Portal";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Other";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Pyszne";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PizzaPortal";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Custom";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ExternalIntegration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "integratorName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "externalOrderOrigin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeExternalOrderOrigin))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Apetilo";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))))))))(encodingOpts)
};
export {
    Takeaway,
    Uber,
    Glovo,
    Wolt,
    Online,
    Phone,
    Bar,
    Portal,
    Other,
    Pyszne,
    PizzaPortal,
    Custom,
    ExternalIntegration,
    Apetilo,
    encodingOpts,
    genericExternalOrderOrigin,
    showExternalOrderOrigin,
    eqExternalOrderOrigin,
    decodeExternalOrderOrigin,
    unscrambleDecodeExternalOrderOrigin,
    encodeExternalOrderOrigin,
    ordExternalOrderOrigin,
    genericOrderOrigin,
    showOrderOrigin,
    eqOrderOrigin,
    decodeOrderOrigin,
    unscrambleDecodeOrderOrigin,
    encodeOrderOrigin,
    ordOrderOrigin
};
//# sourceMappingURL=index.js.map
